module.exports = __webpack_public_path__ + "h5/img/noCart.299ad91f.png";